var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.216,
    height: 32.436,
    viewBox: "0 0 31.216 32.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 31.216,
    height: 32.436,
    transform: "translate(-5 -5)",
    fill: "#0082ca",
    stroke: "#0082ca",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5321",
    "data-name": "Path 5321",
    d: "M17.433,13.848A7.061,7.061,0,0,0,23.03,11a6.667,6.667,0,0,0,1.327-4.071,6.924,6.924,0,1,0-6.924,6.924m0-11.448a4.524,4.524,0,1,1-4.524,4.524A4.527,4.527,0,0,1,17.433,2.4",
    transform: "translate(-6.825 0)",
    fill: "#0082ca",
    stroke: "#0082ca",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5322",
    "data-name": "Path 5322",
    d: "M10.608,41.374C6.132,41.374,0,41.374,0,48.106a1.2,1.2,0,0,0,1.2,1.2H20.016a1.2,1.2,0,0,0,1.2-1.2c0-6.732-6.132-6.732-10.608-6.732M2.5,46.906c.516-2.668,3-3.132,8.1-3.132s7.588.468,8.1,3.132Z",
    transform: "translate(0 -26.87)",
    fill: "#0082ca",
    stroke: "#0082ca",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIconBlue);
export default __webpack_public_path__ + "static/media/account-icon-blue.3972e5e5e60dc7b121e0d65a9275da77.svg";
export { ForwardRef as ReactComponent };